<app-loader *ngIf="isDisabled"></app-loader>
<div>
	<div class="row m-0">
		<div class="col"></div>
		<div class="col-auto">
			<button (click)="openRequestForm(EmployeeId)" type="button" class="btn btn-primary btn-sm" [disabled]="isDisabled">
				<i class="bi bi-suitcase" *ngIf="!isDisabled"></i>
				<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
					*ngIf="isDisabled"></span>
				{{!isDisabled?'Leave Request':'Loading...'}}
			</button>
		</div>
	</div>
</div>

<div class="card border-radius-0 mt-2 p-0">
	<div class="card-header">
		<div class="card-title">
			Leave Request History
		</div>
	</div>
	<div class="card-body">
		<form class="g-3" name="filterForm" (ngSubmit)="Validate(filterForm)" #filterForm="ngForm" novalidate>
			<div class="row pb-2">
				<div class="col-md-3">
					<label for="FromDate" class="text-label-dark">From Date</label>
					<div class="input-group">
						<input class="form-control" placeholder="DD MMM YYYY" name="FromDate"
							[(ngModel)]="Filter.FromDate" ngbDatepicker #FromDate="ngbDatepicker" readonly required
							[disabled]="Filter.IsWithdraw" (ngModelChange)="Clear()"/>
						<button class="btn btn-outline-secondary bi bi-calendar3" (click)="FromDate.toggle()"
							type="button" [disabled]="Filter.IsWithdraw"></button>
					</div>
				</div>
				<div class="col-md-3">
					<label for="ToDate" class="text-label-dark">To Date</label>
					<div class="input-group">
						<input class="form-control" placeholder="DD MMM YYYY" name="ToDate" [(ngModel)]="Filter.ToDate"
							ngbDatepicker #ToDate="ngbDatepicker" readonly required [disabled]="Filter.IsWithdraw" 
							(ngModelChange)="Clear()"/>
						<button class="btn btn-outline-secondary bi bi-calendar3" (click)="ToDate.toggle()"
							type="button" [disabled]="Filter.IsWithdraw"></button>
					</div>
				</div>
				<div class="col-md-2">
					<label for="ApprovalStatus" class="form-font-label">Status</label>
					<select class="form-select" aria-label="ApprovalStatus" placeholder="Status" title="Status"
						name="Status" data-live-search="true" [(ngModel)]="Filter.ApprovalStatus"
						#ApprovalStatus="ngModel" required [disabled]="Filter.IsWithdraw" (change)="Clear()">
						@for (status of common.Status; track status.Value; let i = $index) {
						<option [value]="status.Value">
							<div class="row">
								<div class="col">{{status.Name}}</div>
							</div>
						</option>
						}
					</select>
					<div class="invalid-feedback">
						Please select leave type!
					</div>
				</div>
				<div class="col" style="align-content: center;font-weight: 500;font-size: 15px;">
					<span class="Label" style="margin-left: 3%;">
						<input type="checkbox" name="admincharg" [(ngModel)]="Filter.IsWithdraw" ngbCheckbox
							(change)="Clear()" />
						Withdraw Only
					</span>
				</div>
				<div class="col-md-auto mt-4">
					<button type="submit" class="btn btn-primary btn-sm" [disabled]="isDisabled">
						<i class="bi bi-search" *ngIf="!isDisabled"></i>
						<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
							*ngIf="isDisabled"></span>
						{{!isDisabled?'Search':'Loading...'}}
					</button>
				</div>
			</div>
		</form>
		<div>
			<table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
				class="customeDatatable table table-bordered">
				<thead class="table-light">
					<tr>
						<th scope="col" style="width: 5px;">#</th>
						<th [ngClass]="{'colHide': this.Filter.IsWithdraw}">View</th>
						<th style="width: 5px;" [ngClass]="{'colHide': this.Filter.IsWithdraw}">Withdraw</th>

						<!-- <th>Details</th> -->
						<th style="width: 300px;">{{common.ToLowerCase(user.EmpType) == 'front'?'Client Location':common.ToLowerCase(user.EmpType) == 'back'?'Branch':''}}</th>
						<th style="width: 100px;">Request Date</th>
						<th style="width: 100px;" [ngClass]="{'colHide': !this.Filter.IsWithdraw}">Withdraw Date</th>
						<th>Leave Type</th>
						<th style="width: 100px;">From Date</th>
						<th style="width: 100px;">To Date</th>
						<th [ngClass]="{'colHide': this.Filter.IsWithdraw}">Half Day</th>
						<!-- <th>Half Day Session</th> -->
						<th>No Of Days</th>
						<th style="width: 150px;">Reason</th>
						<th [ngClass]="{'colHide': this.Filter.IsWithdraw}">Status</th>
						<!-- <th>Transaction</th> -->

					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let TableData of EmployeeLeave; let i = index">
						<th scope="row" style="width: 5px;">{{i+1}}</th>
						<td style="width: 5px;" [ngClass]="{'colHide': this.Filter.IsWithdraw}">
							<div (click)="openLeaveDetails(TableData['EmpMasterID'], TableData['EmployeeLeaveDetailsID'])" style="width: 80px;"><button type="button" class="btn btn-outline-primary btn-sm">
                                <i class="bi bi-info-square me-1"></i>View</button></div>
						</td>
						<td style="width: 5px;" [ngClass]="{'colHide': this.Filter.IsWithdraw}">
							<div style="width: 110px;"
								*ngIf="common.ToLowerCase(TableData['ApprovalStatus']) == 'pending' || common.ToLowerCase(TableData['ApprovalStatus']) == 'approved'">
								<button type="button" class="btn btn-outline-primary btn-sm"
									(click)="SaveEmployeeLeaveDetails(i)"><i
										class="bi bi-x-circle me-1"></i>Withdraw</button></div>
						</td>
						<!-- <td>
							<div class="row no-gutters" style="align-items: center;width: 300px;">
								<div class="col-2">
									<img mat-card-image class="userImage rounded" [src]="common.PhotoLink(TableData['Photo'])" />
								</div>
								<div class=" col-10">
									<span class="text-label">{{TableData['FullName']}}</span><br />
									<span class="text-label-light">#{{TableData['EmpCode']}}</span><br />
									<span class="text-label-light">{{TableData['DesignationName']}}</span>
								</div>
							</div>
						</td> -->
						<td style="width: 300px;">
							<div style="width: 300px;">{{common.ToLowerCase(user.EmpType) ==
								'front'?TableData['ClientLocation']:common.ToLowerCase(user.EmpType) ==
								'back'?TableData['BranchName']:''}}</div>
						</td>
						<td style="width: 100px;">
							<div style="width: 100px;">{{TableData['RequestDate'] | date : 'dd MMM yyyy' }}</div>
						</td>
						<td style="width: 100px;" [ngClass]="{'colHide': !this.Filter.IsWithdraw}">
							<div style="width: 100px;">{{TableData['WithdrawDate'] | date : 'dd MMM yyyy' }}</div>
						</td>
						<td>{{TableData['LeaveName']}}</td>
						<td style="width: 100px;">
							<div style="width: 100px;">{{TableData['FromDate'] | date : 'dd MMM yyyy' }}</div>
						</td>
						<td style="width: 100px;">
							<div style="width: 100px;">{{TableData['ToDate'] | date : 'dd MMM yyyy' }}</div>
						</td>
						<td title="{{TableData['HalfDaySession']}}" [ngClass]="{'colHide': this.Filter.IsWithdraw}">
							{{TableData['HalfDay']?'Yes':'No'}}</td>
						<!-- <td>{{TableData['HalfDaySession']}}</td> -->
						<td>{{TableData['NoOfDays']}}</td>
						<td style="width: 150px;">
							<div style="width: 150px;">{{TableData['Reason']}}</div>
						</td>
						<td [ngClass]="{'colHide': this.Filter.IsWithdraw}"><span class="badge"
								[ngClass]="{'success':common.ToLowerCase(TableData['ApprovalStatus']) == 'approved', 'warning':common.ToLowerCase(TableData['ApprovalStatus']) == 'pending','danger':common.ToLowerCase(TableData['ApprovalStatus']) == 'rejected'}">{{TableData['ApprovalStatus']}}</span>
						</td>

						<!-- <td style="width: 5px;">
							<div style="width: 100px;"><button type="button" class="btn btn-outline-primary btn-sm"
									(click)="Tracking(TableData['EmployeeLeaveDetailsID'])"><i
										class="bi bi-clock-history me-2"></i>History</button></div>
						</td> -->

					</tr>
				</tbody>
			</table>

		</div>

	</div>


</div>